
import * as React from 'react';
import styled from 'styled-components';
// $FlowFixMe
import { Modal, Button } from '@bijie/react-bnb';

import withI18n from '../../utils/withI18n';
import { getLabel } from '../../utils/i18n';

const Content = styled.div`
  width: 100%;
  text-align: center;
  > h3 {
    margin: 30px 0 20px;
    font-size:24px;
    font-weight:500;
    color:rgba(33,40,51,1);
    line-height:32px;
  }
  > p {
    margin-bottom: 30px;
    font-size:14px;
    font-family:${({ theme }) => theme.fontIBMRegular};
    color:rgba(72,81,93,1);
    line-height:20px;
    a, a:visited {
      color: ${({ theme }) => theme.highlight};
    }
    a:hover {
      text-decoration: underline;
    }
  }
`;

type Props = {
  i18n: Object,
}

type State = {
  isShowTip: boolean,
  version: string,
}

export default
@withI18n
class News extends React.PureComponent<Props, State> {
  static defaultProps = {
    i18n: {},
  };

  state = {
    isShowTip: false,
    version: '',
  }


  componentDidMount() {
    const isShowFirefoxTip = localStorage.getItem('isShowFirefoxTip');
    if (isShowFirefoxTip === 'false') return;
    const { browser, ver } = this._getBrowserInfo();
    if (browser === 'firefox' && Number(ver) < 67.1) {
      this.setState({ isShowTip: true, version: ver });
      localStorage.setItem('isShowFirefoxTip', 'false');
    }
  }

  _getBrowserInfo = () => {
    const Sys = {};
    const ua = navigator.userAgent.toLowerCase();
    const re = /(msie|firefox|chrome|opera|version).*?([\d.]+)/;
    const m = ua.match(re);
    // $FlowFixMe
    Sys.browser = m[1].replace(/version/, "'safari");
    // eslint-disable-next-line
    Sys.ver = m[2];
    return Sys;
  }

  render() {
    const {
      i18n,
    } = this.props;
    const { isShowTip, version } = this.state;
    return (
      <Modal
        title={false}
        footer={false}
        visible={isShowTip}
        width={440}
        onCancel={() => this.setState({ isShowTip: false })}
        closable={false}
      >
        <Content>
          <img src={require('./warning.svg')} alt="waring" />
          <h3>{getLabel('exchange-security-firefoxTipTitle', i18n)}</h3>
          <p dangerouslySetInnerHTML={{ __html: getLabel('exchange-security-firefoxTipDesc', i18n).replace('##', version) }} />
          <Button
            id="firefox_warning_iUnderstood"
            type="primary"
            block={true}
            size="lg"
            onClick={() => this.setState({ isShowTip: false })}
          >
            {getLabel('exchange-register-IUnderstood', i18n)}
          </Button>
        </Content>
      </Modal>
    );
  }
}
